exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* CAROUSEL */\r\n.carousel-indicators li {\r\n    background: #eef0f4;\r\n    opacity: .5;\r\n}\r\n\r\n.carousel-indicators li.active {\r\n    opacity: 1;\r\n    background: #eef0f4;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null],"sourceMap":false}!./src/assets/modules/vendors/bootstrap/css/carousel.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null,null],"sourceMap":false}!./src/assets/modules/vendors/bootstrap/css/carousel.css
// module chunks = styles